import { Box } from "@mui/material";
import { EstimationTable } from "./EstimationTable";

export function EstimationTab() {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", p: 2, gap: 2, bgcolor: "background.default" }}>
      <EstimationTable />
    </Box>
  );
}
